import { Injectable, inject } from '@angular/core';

import { ProductV2 } from '../models/product-v2.model';
import { CartFacade } from '../store/cart/cart.facade';

@Injectable({ providedIn: 'root' })
export class ProductPageMindCartService {
  private cartFacade = inject(CartFacade);

  addCatalogProduct(product: ProductV2 | null | undefined): void {
    if (product?.productType !== 'MIND') {
      return;
    }
    this.cartFacade.addToCart(product, 1, undefined);
  }
}
